<template>
 <v-container class="pt-1 pb-12 py-sm-12 px-4 px-sm-0">

    <v-overlay :value="dataset.loading" absolute>
      <v-progress-circular indeterminate size="64" />
    </v-overlay>

    <!-- HEADER DESKTOP -->
<v-row class="d-none d-sm-flex">
      <v-col cols="12">
        <div class="title-container d-flex justify-space-between align-center">
          <div class="title-block">
            <div class="d-flex align-center ga-3">
              <span class="page-title">{{ page.title }}</span>
              <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small color="primary" text v-bind="attrs" v-on="on">
                    <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
                  </v-btn>
                </template>
                <v-card min-width="380px">
                  <v-card-title class="text-h6 font-weight-bold pb-2">
                    <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pt-3 pb-3">
                   <div class="mb-3"><p class="font-weight-bold text-caption mb-1">👤 Nome</p><p class="text-caption grey--text">Como o cliente se chama</p></div>
<v-divider class="my-2"></v-divider>
<div class="mb-3"><p class="font-weight-bold text-caption mb-1">🪪 CPF</p><p class="text-caption grey--text">Usado para identificar o cliente no totem</p></div>
<v-divider class="my-2"></v-divider>
<div class="mb-3"><p class="font-weight-bold text-caption mb-1">📱 Telefone</p><p class="text-caption grey--text">Número com DDD para contato via WhatsApp</p></div>
<v-divider class="my-2"></v-divider>
<div class="mb-3"><p class="font-weight-bold text-caption mb-1">📅 Data de Cadastro</p><p class="text-caption grey--text">Quando esse cliente foi cadastrado</p></div>
<v-divider class="my-2"></v-divider>
<div><p class="font-weight-bold text-caption mb-1">🚦 Situação</p><p class="text-caption grey--text">Habilitado = pode usar o totem. Bloqueado = acesso negado</p></div>
                  </v-card-text>
                </v-card>
              </v-menu>
            </div>
            <v-breadcrumbs
              class="app-breadcrumb"
              divider="›"
              :items="dataset.breadcrumbItems"
            />
          </div>
       <div class="button-group">
<v-btn
    type="button"
    elevation="0"
    outlined
    depressed
    style="color: #3BA5DB !important; border-color: #3BA5DB !important;"
    @click="voltar"
    :disabled="dataset.loading"
  >
    Voltar
  </v-btn>
  <v-btn
    color="info"
    dark
    @click="abrirConfirmacao"
    :loading="dataset.loading"
  >
    Salvar
  </v-btn>
</div>
        </div>
      </v-col>
    </v-row>

  <!-- HEADER MOBILE -->
<v-row class="d-flex d-sm-none mb-4">
  <v-col cols="12">
    <div>
    <div class="d-flex align-center">
    <span class="page-title">{{ page.title }}</span>
    <v-btn icon small color="primary" class="ml-2" @click="dialogAjudaMobile = true">
        <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>
</div>
      <div style="font-size: 13px; color: #666; margin-top: 2px;">
        <span style="color:#333333; cursor:pointer;" @click="$router.push('/home')">Homepage</span>
        <span> › </span>
        <span style="color:#333333; cursor:pointer;" @click="$router.push('/clientes')">Clientes</span>
        <span> › </span>
        <span>Editar Cliente</span>
      </div>
    </div>
  </v-col>
 <v-col cols="6">
 <v-btn type="button" elevation="0" color="primary" outlined depressed block @click="voltar" :disabled="dataset.loading">Voltar</v-btn>
</v-col>
<v-col cols="6">
  <v-btn color="info" dark block @click="abrirConfirmacao" :loading="dataset.loading">Salvar</v-btn>
</v-col>
</v-row>

    <v-form ref="form" v-model="valid" :disabled="dataset.loading">

      <!-- DETALHES -->
      <v-row>
  <v-col cols="12">
    <v-card class="card-form-outlined">
      <v-card-title class="card-group-title">
        Detalhes do Cliente
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row dense>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              dense
              label="Nome"
              v-model="cliente.nome"
              outlined
              :rules="[rules.required]"
              hide-details="auto"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              dense
              label="CPF"
              v-model="cliente.cpf"
              outlined
              v-mask="'###.###.###-##'"
              :rules="[rules.cpf]"
              hide-details="auto"
            />
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <v-text-field
              dense
              label="Telefone"
              v-model="cliente.telefone"
              outlined
              v-mask="'(##) #####-####'"
              hide-details="auto"
            />
          </v-col>

                <!-- EMAIL AGORA POR ÚLTIMO -->
                 <!-- EMAIL AGORA POR ÚLTIMO -->
                <!-- <v-col cols="12" sm="6">
                         <v-text-field
                            dense
                       label="E-mail"
                       v-model="cliente.email"
                        outlined
              :rules="[rules.required, rules.email]"
                          />
                 </v-col> -->

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- INFORMAÇÕES -->
      <v-row>
        <v-col cols="12">
          <v-card class="card-form-outlined">
            <v-card-title class="card-group-title">Informações</v-card-title>
            <v-card-text>
              <div>
                <strong>Data de Cadastro:</strong>
                {{ formatarDataHora(cliente.dataCadastro) }}
              </div>
              <div class="mt-2">
                <strong>Última Visita:</strong>
                {{ formatarDataHora(cliente.ultimaVisita) }}
              </div>
              <div class="mt-2">
             <strong>Situação: </strong>
            <span :class="!cliente.bloqueado ? 'green--text' : 'error--text'">
    <strong>{{ cliente.bloqueado ? 'Bloqueado' : 'Habilitado' }}</strong>
  </span>
</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
<!-- SALDO E MOVIMENTAÇÕES -->
<v-row>
  <v-col cols="12">
    <v-card class="card-form-outlined">
      <v-card-title class="card-group-title d-flex flex-column flex-sm-row justify-space-between align-start align-sm-center">
        <span>Saldo e Movimentações</span>
        <span class="mt-2 mt-sm-0 text-sm-right" style="font-size: 20px; font-weight: 700; color: #333;">
          Saldo atual: R$ {{ Number(cliente.saldoAtual || 0).toFixed(2).replace('.', ',') }}
        </span>
      </v-card-title>

        <!-- BOTÕES CRÉDITO/DÉBITO -->
      <v-card-text class="pt-0">
    <v-row class="mb-4 mx-0" dense>
          <v-col cols="6" sm="auto" class="pr-1 pr-sm-3 mb-2">
            <v-btn color="success" dark depressed block :class="{ 'px-6': $vuetify.breakpoint.smAndUp }" @click="dialogCredito = true">
              <v-icon left>mdi-plus</v-icon>
              Adicionar
            </v-btn>
          </v-col>
          <v-col cols="6" sm="auto" class="pl-1 mb-2">
            <v-btn style="background-color: #f44336 !important; color: white !important;" dark depressed block :class="{ 'px-6': $vuetify.breakpoint.smAndUp }" @click="dialogDebito = true">
  <v-icon left>mdi-minus</v-icon>
  Remover
</v-btn>
          </v-col>
        </v-row>

        <v-row class="mx-0 mb-2">
          <v-btn
            outlined
            color="primary"
            block
            @click="abrirPopupSaldoMobile"
          >
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Ver movimentações
          </v-btn>
        </v-row>

        <div class="d-none">

        <!-- FILTRO PERÍODO MOVIMENTAÇÕES -->
         <v-row class="mb-3" align="center">
            <v-col cols="12" sm="3">
              <v-select
                dense outlined label="Período"
                :items="movimentacao.periodTypes"
                v-model="movimentacao.filterSelected"
                item-value="type" item-text="label"
                @change="normalizePeriodoMovimentacao"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="movimentacao.dataInicial"
                type="datetime-local"
                :disabled="movimentacao.filterSelected != 4"
                dense label="Data início" outlined hide-details
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="movimentacao.dataFinal"
                type="datetime-local"
                :disabled="movimentacao.filterSelected != 4"
                dense label="Data fim" outlined hide-details
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn color="primary" @click="carregarMovimentacoes">Filtrar</v-btn>
            </v-col>
          </v-row>

        <!-- TABELA MOVIMENTAÇÕES -->
<v-data-table
  :headers="movimentacaoHeaders"
  :items="movimentacao.data"
  :loading="movimentacao.loading"
  :server-items-length="movimentacao.total"
  :options.sync="movimentacao.options"
  no-data-text="Nenhuma movimentação encontrada"
  loading-text="Carregando..."
  class="app-table cliente-edit-popup-table"
  hide-default-footer
>
            <template v-slot:item.data="{ item }">
              <span class="d-block text-left">{{ formatarDataHora(item.data) }}</span>
            </template>
            <template v-slot:item.origem="{ item }">
              <span class="d-block text-left">
                {{ item.comboNome
                    ? item.comboNome
                    : item.origem
                        ? (item.origem === 'PORTAL' ? 'Portal' : item.origem === 'TOTEM' ? 'Totem' : item.origem === 'CASHBACK' ? 'Cashback' : item.origem === 'COMBO' ? 'Combo' : item.origem) + (item.usuarioNome ? ' · ' + item.usuarioNome : '')
                        : '-'
                }}
              </span>
            </template>
            <template v-slot:item.tipo="{ item }">
              <span class="d-block text-left" :class="item.tipo === 'CREDITO' ? 'green--text' : 'error--text'">
                <strong>{{ item.tipo === 'CREDITO' ? 'Crédito' : 'Débito' }}</strong>
              </span>
            </template>
         <template v-slot:item.valor="{ item }">
              <span class="d-block text-center">R$ {{ Number(item.valor).toFixed(2).replace('.', ',') }}</span>
            </template>
         <template v-slot:item.acoes="{ item }">
  <span class="d-block text-right">
    <v-btn icon small color="primary" @click="verDetalheMovimentacao(item)">
      <v-icon small>mdi-eye-outline</v-icon>
    </v-btn>
  </span>
</template>
          </v-data-table>
        </div>
      </v-card-text> 
    </v-card>
  </v-col>
</v-row>

<!-- HISTÓRICO DE COMPRAS -->
<v-row class="mt-4">
  <v-col cols="12">
    <v-card class="card-form-outlined">
      <v-card-title class="card-group-title">Histórico de Compras</v-card-title>
      <v-card-text>

        <!-- MOBILE: botão para abrir popup com histórico -->
      <v-row class="mx-0 mb-2">
          <v-btn
            outlined
            color="primary"
            block
            @click="abrirPopupHistoricoMobile"
          >
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Ver histórico de compras
          </v-btn>
        </v-row>

        <!-- DESKTOP: conteúdo completo sempre visível -->
        <div class="d-none">
          <!-- FILTRO PERÍODO -->
          <v-row class="mb-3" align="center">
            <v-col cols="12" sm="6" md="3" class="pb-2 pb-md-0">
              <v-select 
                dense outlined label="Período"
                :items="historico.periodTypes"
                v-model="historico.filterSelected"
                item-value="type"
                item-text="label"
                @change="normalizeRangeByType"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pb-2 pb-md-0">
              <v-text-field 
                v-model="historico.dataInicial" 
                type="datetime-local"
                :disabled="historico.filterSelected != 4" 
                dense label="Data início" outlined hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pb-2 pb-md-0">
              <v-text-field 
                v-model="historico.dataFinal" 
                type="datetime-local"
                :disabled="historico.filterSelected != 4" 
                dense label="Data fim" outlined hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="d-flex align-center">
              <v-btn 
                color="primary" 
                @click="carregarHistorico"
                :block="$vuetify.breakpoint.xsOnly"
              >
                Filtrar
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
  :headers="historicoHeaders"
  :items="historico.data"
  :loading="historico.loading"
  :server-items-length="historico.total"
  :options.sync="historico.options"
  no-data-text="Nenhuma compra encontrada"
  loading-text="Carregando histórico..."
  class="app-table cliente-edit-popup-table"
  hide-default-footer
>
            <template v-slot:item.data="{ item }">
              {{ formatarDataHora(item.data) }}
            </template>

            <template v-slot:item.maquina="{ item }">
              <div v-if="item.vendaItens && item.vendaItens.length">
                <span v-if="item.vendaItens.some(i => i.descricao && !i.descricao.startsWith('Combo:'))">
                  {{ item.vendaItens.map(i => i.descricao).filter(d => d && !d.startsWith('Combo:')).join(', ') }}
                </span>
              </div>
            </template>

            <template v-slot:item.valor="{ item }">
              R$ {{ Number(item.valorFinal || item.valor).toFixed(2).replace('.', ',') }}
            </template>

              <template v-slot:item.tipoPagamento="{ item }">
              <span class="d-block text-center">{{ formatarTipoPagamento(item.tipoPagamento) }}</span>
            </template>

            <template v-slot:item.acoes="{ item }">
              <span class="d-block text-right">
                <v-btn icon small color="primary" @click="verDetalheCompra(item)">
                  <v-icon small>mdi-eye-outline</v-icon>
                </v-btn>
              </span>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>

<!-- AÇÕES -->
         <v-row>
      <v-col cols="12">
        <v-card class="card-form-outlined">
          <v-card-title class="card-group-title">Ações</v-card-title>
          <v-card-text>
  <v-row no-gutters>
    <v-col cols="12" sm="auto" class="mb-2 mb-sm-0 mr-sm-3">
      <v-btn
        :outlined="!cliente.bloqueado"
        :style="!cliente.bloqueado ? 'color: #f44336 !important; border-color: #f44336 !important;' : ''"
        :color="cliente.bloqueado ? 'success' : ''"
        :dark="cliente.bloqueado"
        block
        @click="alternarStatusCliente"
        :loading="dataset.loading"
      >
        {{ cliente.bloqueado ? 'Habilitar' : 'Bloquear' }}
      </v-btn>
    </v-col>
    <v-col cols="12" sm="auto" class="mb-2 mb-sm-0 mr-sm-3">
      <v-btn style="background-color: #f44336 !important; color: white !important;" dark block @click="dialogExcluir = true">
        Excluir Cliente
      </v-btn>
    </v-col>
    <v-col cols="12" sm="auto">
      <v-btn color="success" dark block @click="abrirWhatsApp">
        <v-icon left>mdi-whatsapp</v-icon>
        WhatsApp
      </v-btn>
    </v-col>
  </v-row>
</v-card-text>
        </v-card>
      </v-col>
    </v-row>


    </v-form>

   <!-- CONFIRMAR SALVAR -->
<v-dialog v-model="dialogConfirmar" max-width="400">
  <v-card>
    <v-card-title>Atualizar cliente</v-card-title>
    <v-card-text>Deseja atualizar o cliente?</v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="dialogConfirmar = false">Cancelar</v-btn>
      <v-btn text @click="salvarCliente">Atualizar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- DIALOG CRÉDITO -->
<v-dialog v-model="dialogCredito" max-width="400">
  <v-card>
    <v-card-title>Adicionar Crédito</v-card-title>
    <v-card-text>
    <v-text-field
  v-model="movimentacao.valor"
  label="Valor (R$)"
  placeholder="0,00"
  outlined dense
  reverse
  @input="formatarValorMovimentacao"
/>
 <v-textarea     
    v-model="movimentacao.observacao"
    label="Observação (opcional)"
    outlined dense rows="3"
    maxlength="128" counter="128"
    hide-details="auto" class="mt-2"
  />
    </v-card-text>
        <v-card-actions class="justify-end">
      <v-btn text @click="dialogCredito = false">Cancelar</v-btn>
      <v-btn color="primary" dark @click="registrarMovimentacao('CREDITO')">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- DIALOG DÉBITO -->
<v-dialog v-model="dialogDebito" max-width="400">
  <v-card>
    <v-card-title>Remover Crédito</v-card-title>
    <v-card-text>
    <v-text-field
  v-model="movimentacao.valor"
  label="Valor (R$)"
  placeholder="0,00"
  outlined dense
  reverse
  @input="formatarValorMovimentacao"
/>
<v-textarea     
    v-model="movimentacao.observacao"
    label="Observação (opcional)"
    outlined dense rows="3"
    maxlength="128" counter="128"
    hide-details="auto" class="mt-2"
  />
    </v-card-text>
    <v-card-actions class="justify-end">
  <v-btn text @click="dialogDebito = false">Cancelar</v-btn>
  <v-btn color="primary" dark @click="registrarMovimentacao('DEBITO')">Confirmar</v-btn>
</v-card-actions>
  </v-card>
</v-dialog>
    

       <!-- CONFIRMAR EXCLUIR -->
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card>
        <v-card-title>Excluir Cliente</v-card-title>
        <v-card-text>Deseja realmente excluir este cliente?</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogExcluir = false">Cancelar</v-btn>
          <v-btn style="background-color: #f44336 !important; color: white !important;" @click="excluirCliente">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- POPUP MOVIMENTAÇÕES (MOBILE) -->
<v-dialog v-model="dialogSaldoMobile" :max-width="$vuetify.breakpoint.smAndUp ? 1100 : 480" scrollable content-class="popup-mobile-dialog">
  <v-card>
  <div class="popup-mobile-header">
  <span class="popup-mobile-header-title">Movimentações</span>
  <v-btn icon small class="popup-mobile-close" @click="dialogSaldoMobile = false">
    <v-icon size="18">mdi-close</v-icon>
  </v-btn>
</div>
<v-divider></v-divider>

<v-card-text class="pt-4">
  <div class="popup-mobile-saldo mb-4" style="font-size: 18px; font-weight: 700; color: #333; margin-bottom: 24px !important;">
    Saldo atual: R$ {{ Number(cliente.saldoAtual || 0).toFixed(2).replace('.', ',') }}
  </div>

<!-- MOBILE (inalterado) -->
      <v-row class="mb-2 d-flex d-sm-none" dense align="center">
    <v-col cols="12">
      <v-select
        dense outlined label="Período"
        :items="movimentacao.periodTypes"
        v-model="movimentacao.filterSelected"
        item-value="type" item-text="label"
        @change="normalizePeriodoMovimentacao"
        hide-details
      />
    </v-col>

    <v-col cols="12" v-if="movimentacao.filterSelected == 4">
      <v-text-field
        v-model="movimentacao.dataInicial"
        type="date"
        dense label="Data início" outlined hide-details
        class="popup-date-field"
      />
    </v-col>
    <v-col cols="12" v-if="movimentacao.filterSelected == 4">
      <v-text-field
        v-model="movimentacao.dataFinal"
        type="date"
        dense label="Data fim" outlined hide-details
        class="popup-date-field"
      />
    </v-col>

<v-col cols="6" class="pr-1">
      <v-btn color="primary" block :loading="movimentacao.filtering" @click="carregarMovimentacoes" style="width: 100%;">Filtrar</v-btn>
    </v-col>
    <v-col cols="6" class="pl-1">
      <v-btn
        outlined color="primary"
        block
        class="popup-exportar-btn"
        :loading="movimentacao.exporting"
        @click="exportarMovimentacoes"
        style="width: 100%;"
      >
        <v-icon left small>mdi-file-excel-outline</v-icon>
        Exportar
      </v-btn>
    </v-col>
  </v-row>

          <!-- DESKTOP: tudo em uma linha -->
<v-form @submit.prevent="carregarMovimentacoes">
<v-row class="mb-3 d-none d-sm-flex flex-nowrap" dense align="center">
  <v-col cols="auto">
    <div class="d-flex align-center" style="gap: 8px;">
      <v-btn
        v-for="item in movimentacao.periodTypes"
        :key="item.type"
        :color="movimentacao.filterSelected === item.type ? 'primary' : 'default'"
        :outlined="movimentacao.filterSelected !== item.type"
        small
        depressed
        height="40"
        type="button"
        @click="movimentacao.filterSelected = item.type; normalizePeriodoMovimentacao();"
      >
        {{ item.label }}
   </v-btn>
    </div>
  </v-col>
<v-col cols="2">
  <v-text-field
    v-model="movimentacao.dataInicial"
    type="date"
    dense
    label="Data início"
    outlined
    hide-details
    :disabled="movimentacao.filterSelected !== 4"
    @keyup.enter="carregarMovimentacoes"
  />
</v-col>
<v-col cols="2">
  <v-text-field
    v-model="movimentacao.dataFinal"
    type="date"
    dense
    label="Data fim"
    outlined
    hide-details
    :disabled="movimentacao.filterSelected !== 4"
    @keyup.enter="carregarMovimentacoes"
  />
</v-col>
<v-col cols="auto">
    <v-btn
      type="submit"
      color="primary"
      height="40"
      width="110"
      :loading="movimentacao.loading"
    >
      Filtrar
    </v-btn>
  </v-col>
  <v-col cols="auto">
  <v-btn
    type="button"
    color="primary"
    outlined
    class="popup-exportar-btn"
    height="40"
    width="110"
    :loading="movimentacao.exporting"
    @click="exportarMovimentacoes"
  >
    Exportar
  </v-btn>
</v-col>
</v-row>
</v-form>


       <v-data-table
  :headers="movimentacaoHeaders"
  :items="movimentacao.data"
  :loading="movimentacao.loading"
  :server-items-length="movimentacao.total"
  :options.sync="movimentacao.options"
  no-data-text="Nenhuma movimentação encontrada"
  loading-text="Carregando..."
  class="app-table cliente-edit-popup-table"
  hide-default-footer
>
            <template v-slot:item.data="{ item }">
              <span class="d-block text-left">{{ formatarDataHora(item.data) }}</span>
            </template>
          <template v-slot:item.origem="{ item }">
              <span class="d-block text-left">
                {{ item.comboNome
                    ? item.comboNome
                    : item.origem
                        ? (item.origem === 'PORTAL' ? 'Portal' : item.origem === 'TOTEM' ? 'Totem' : item.origem === 'CASHBACK' ? 'Cashback' : item.origem === 'COMBO' ? 'Combo' : item.origem) + (item.usuarioNome ? ' · ' + item.usuarioNome : '')
                        : '-'
                }}
              </span>
            </template>
            <template v-slot:item.tipo="{ item }">
              <span class="d-block text-left" :class="item.tipo === 'CREDITO' ? 'green--text' : 'error--text'">
                <strong>{{ item.tipo === 'CREDITO' ? 'Crédito' : 'Débito' }}</strong>
              </span>
            </template>
          <template v-slot:item.valor="{ item }">
              <span class="d-block text-center">R$ {{ Number(item.valor).toFixed(2).replace('.', ',') }}</span>
            </template>
    <template v-slot:item.acoes="{ item }">
  <span class="d-block text-right">
    <v-btn icon small color="primary" @click="verDetalheMovimentacao(item)">
      <v-icon small>mdi-eye-outline</v-icon>
    </v-btn>
  </span>
</template>
      </v-data-table>
        <div class="popup-custom-pagination">
          <div class="popup-pagination-topo">
            <v-select
              :items="[10, 20]"
              v-model="movimentacao.options.itemsPerPage"
              dense
              outlined
              hide-details
              class="popup-itens-por-pagina"
            />
            <span class="popup-pagination-label">
              Página {{ movimentacao.options.page }} de {{ totalPaginasMovimentacao }}
            </span>
          </div>
          <div class="popup-pagination-botoes">
            <v-btn text small color="primary" :disabled="movimentacao.options.page <= 1" @click="paginaAnteriorMovimentacao">
              <v-icon left small>mdi-chevron-left</v-icon>
              Anterior
            </v-btn>
            <v-btn text small color="primary" :disabled="movimentacao.options.page >= totalPaginasMovimentacao" @click="paginaProximaMovimentacao">
              Próxima
              <v-icon right small>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>

<!-- POPUP HISTÓRICO DE COMPRAS (MOBILE) -->
<v-dialog v-model="dialogHistoricoMobile" :max-width="$vuetify.breakpoint.smAndUp ? 1100 : 480" scrollable content-class="popup-mobile-dialog">
  <v-card>
   <div class="popup-mobile-header">
  <span class="popup-mobile-header-title">Histórico de Compras</span>
  <v-btn icon small class="popup-mobile-close" @click="dialogHistoricoMobile = false">
    <v-icon size="18">mdi-close</v-icon>
  </v-btn>
</div>
<v-divider></v-divider>

<v-card-text class="pt-4">

  <!-- MOBILE -->
  <v-row class="mb-2 d-flex d-sm-none" dense align="center">
    <v-col cols="12">
      <v-select
        dense outlined label="Período"
        :items="historico.periodTypes"
        v-model="historico.filterSelected"
        item-value="type"
        item-text="label"
        @change="normalizeRangeByType"
        hide-details
      ></v-select>
    </v-col>
    <v-col cols="12" v-if="historico.filterSelected == 4">
      <v-text-field
        v-model="historico.dataInicial"
        type="date"
        dense label="Data início" outlined hide-details
        class="popup-date-field"
      ></v-text-field>
    </v-col>
    <v-col cols="12" v-if="historico.filterSelected == 4">
      <v-text-field
        v-model="historico.dataFinal"
        type="date"
        dense label="Data fim" outlined hide-details
        class="popup-date-field"
      ></v-text-field>
    </v-col>
    <v-col cols="6" class="pr-1">
      <v-btn
        color="primary"
        block
        :loading="historico.filtering"
        @click="carregarHistorico"
        style="width: 100%;"
      >
        Filtrar
      </v-btn>
    </v-col>
    <v-col cols="6" class="pl-1">
      <v-btn
        outlined
        color="primary"
        block
        class="popup-exportar-btn"
        :loading="historico.exporting"
        @click="exportarHistorico"
        style="width: 100%;"
      >
        <v-icon left small>mdi-file-excel-outline</v-icon>
        Exportar
      </v-btn>
    </v-col>
  </v-row>
  
  <!-- DESKTOP: tudo em uma linha -->
<v-form @submit.prevent="carregarHistorico">
<v-row class="mb-3 d-none d-sm-flex flex-nowrap" dense align="center">
  <v-col cols="auto">
    <div class="d-flex align-center" style="gap: 8px;">
      <v-btn
        v-for="item in historico.periodTypes"
        :key="item.type"
        :color="historico.filterSelected === item.type ? 'primary' : 'default'"
        :outlined="historico.filterSelected !== item.type"
        small
        depressed
        height="40"
        type="button"
        @click="historico.filterSelected = item.type; normalizeRangeByType();"
      >
        {{ item.label }}
      </v-btn>
    </div>
  </v-col>
<v-col cols="2">
  <v-text-field
    v-model="historico.dataInicial"
    type="date"
    dense
    label="Data início"
    outlined
    hide-details
    :disabled="historico.filterSelected !== 4"
    @keyup.enter="carregarHistorico"
  />
</v-col>
<v-col cols="2">
  <v-text-field
    v-model="historico.dataFinal"
    type="date"
    dense
    label="Data fim"
    outlined
    hide-details
    :disabled="historico.filterSelected !== 4"
    @keyup.enter="carregarHistorico"
  />
</v-col>
    <v-col cols="auto">
    <v-btn
      type="submit"
      color="primary"
      height="40"
      width="110"
      :loading="historico.filtering"
    >
      Filtrar
    </v-btn>
  </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto">
      <v-btn
        type="button"
        color="primary"
        outlined
        class="popup-exportar-btn"
        height="40"
        width="110"
        :loading="historico.exporting"
        @click="exportarHistorico"
      >
        Exportar
      </v-btn>
    </v-col>
  </v-row>
</v-form>



      <v-data-table
  :headers="historicoHeaders"
  :items="historico.data"
  :loading="historico.loading"
  :server-items-length="historico.total"
  :options.sync="historico.options"
  no-data-text="Nenhuma compra encontrada"
  loading-text="Carregando histórico..."
  class="app-table cliente-edit-popup-table"
  hide-default-footer
>
            <template v-slot:item.data="{ item }">
              {{ formatarDataHora(item.data) }}
            </template>

          <template v-slot:item.maquina="{ item }">
              <span>
                {{
                  (item.vendaItens && item.vendaItens.some(i => i.descricao && !i.descricao.startsWith('Combo:')))
                    ? item.vendaItens.map(i => i.descricao).filter(d => d && !d.startsWith('Combo:')).join(', ')
                    : '-'
                }}
              </span>
            </template>

            <template v-slot:item.valor="{ item }">
              R$ {{ Number(item.valorFinal || item.valor).toFixed(2).replace('.', ',') }}
            </template>

                <template v-slot:item.tipoPagamento="{ item }">
              <span class="d-block text-center">{{ formatarTipoPagamento(item.tipoPagamento) }}</span>
            </template>

            <template v-slot:item.acoes="{ item }">
              <span class="d-block text-right">
                <v-btn icon small color="primary" @click="verDetalheCompra(item)">
                  <v-icon small>mdi-eye-outline</v-icon>
                </v-btn>
              </span>
            </template>
          </v-data-table>
          <div class="popup-custom-pagination">
            <div class="popup-pagination-topo">
              <v-select
                :items="[10, 20]"
                v-model="historico.options.itemsPerPage"
                dense
                outlined
                hide-details
                class="popup-itens-por-pagina"
              />
              <span class="popup-pagination-label">
                Página {{ historico.options.page }} de {{ totalPaginasHistorico }}
              </span>
            </div>
            <div class="popup-pagination-botoes">
              <v-btn text small color="primary" :disabled="historico.options.page <= 1" @click="paginaAnteriorHistorico($event)">
                <v-icon left small>mdi-chevron-left</v-icon>
                Anterior
              </v-btn>
              <v-btn text small color="primary" :disabled="historico.options.page >= totalPaginasHistorico" @click="paginaProximaHistorico($event)">
                Próxima
                <v-icon right small>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
<!-- DETALHE DA MOVIMENTAÇÃO -->
 <v-dialog v-model="dialogDetalheMovimentacao" max-width="420">
    <v-card>
      <v-card-title class="text-body-1 font-weight-bold" style="word-break: normal;">Detalhes da Movimentação</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <div class="mb-3">
          <strong>Data:</strong>
          <div>{{ formatarDataHora(movimentacaoSelecionada.data) }}</div>
        </div>
        <div class="mb-3">
          <strong>Origem:</strong>
          <div>
           {{ movimentacaoSelecionada.comboNome
                ? movimentacaoSelecionada.comboNome
                : movimentacaoSelecionada.origem
                    ? (movimentacaoSelecionada.origem === 'PORTAL' ? 'Portal' : movimentacaoSelecionada.origem === 'TOTEM' ? 'Totem' : movimentacaoSelecionada.origem === 'CASHBACK' ? 'Cashback' : movimentacaoSelecionada.origem === 'COMBO' ? 'Combo' : movimentacaoSelecionada.origem) + (movimentacaoSelecionada.usuarioNome ? ' · ' + movimentacaoSelecionada.usuarioNome : '')
                    : '-'
            }}
          </div>
        </div>
        <div class="mb-3">
          <strong>Tipo:</strong>
          <div :class="movimentacaoSelecionada.tipo === 'CREDITO' ? 'green--text' : 'error--text'">
            <strong>{{ movimentacaoSelecionada.tipo === 'CREDITO' ? 'Crédito' : 'Débito' }}</strong>
          </div>
        </div>
        <div class="mb-3">
          <strong>Valor:</strong>
          <div>R$ {{ Number(movimentacaoSelecionada.valor || 0).toFixed(2).replace('.', ',') }}</div>
        </div>
        <div>
          <strong>Observação:</strong>
          <div>{{ movimentacaoSelecionada.observacao || 'Nenhuma observação registrada.' }}</div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text @click="dialogDetalheMovimentacao = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

<!-- DETALHE DA COMPRA -->
<v-dialog v-model="dialogDetalheCompra" max-width="420" scrollable content-class="popup-mobile-dialog">
  <v-card>
    <div class="popup-mobile-header">
      <span class="popup-mobile-header-title">Detalhes da Compra</span>
      <v-btn icon small class="popup-mobile-close" @click="dialogDetalheCompra = false">
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <v-card-text class="pt-4">
      <div class="mb-3">
        <strong>Data:</strong>
        <div>{{ formatarDataHora(compraSelecionada.data) }}</div>
      </div>
      <div class="mb-3">
        <strong>Máquina:</strong>
        <div>
          {{
            (compraSelecionada.vendaItens && compraSelecionada.vendaItens.some(i => i.descricao && !i.descricao.startsWith('Combo:')))
              ? compraSelecionada.vendaItens.map(i => i.descricao).filter(d => d && !d.startsWith('Combo:')).join(', ')
              : '-'
          }}
        </div>
      </div>
      <div class="mb-3" v-if="compraSelecionada.cupomDesconto">
        <strong>Cupom:</strong>
        <div>{{ compraSelecionada.cupomDesconto.codigo || '-' }}</div>
      </div>
      <div class="mb-3" v-if="compraSelecionada.valorDesconto">
        <strong>Valor desconto:</strong>
        <div>R$ {{ Number(compraSelecionada.valorDesconto || 0).toFixed(2).replace('.', ',') }}</div>
      </div>
      <div class="mb-3">
        <strong>Valor final:</strong>
        <div>R$ {{ Number(compraSelecionada.valorFinal || compraSelecionada.valor || 0).toFixed(2).replace('.', ',') }}</div>
      </div>
      <div>
        <strong>Tipo de Pagamento:</strong>
        <div>{{ formatarTipoPagamento(compraSelecionada.tipoPagamento) }}</div>
      </div>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="dialogDetalheCompra = false">Fechar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="dialogAjudaMobile" scrollable content-class="popup-mobile-dialog">
    <v-card>
        <div class="popup-mobile-header">
            <span class="popup-mobile-header-title">
                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
            </span>
            <v-btn icon small class="popup-mobile-close" @click="dialogAjudaMobile = false">
                <v-icon size="18">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">👤 Nome</p><p class="text-caption grey--text">Como o cliente se chama</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🪪 CPF</p><p class="text-caption grey--text">Usado para identificar o cliente no totem</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📱 Telefone</p><p class="text-caption grey--text">Número com DDD para contato via WhatsApp</p></div>
            <v-divider class="my-2"></v-divider>
            <div><p class="font-weight-bold text-caption mb-1">🚦 Situação</p><p class="text-caption grey--text">Habilitado = pode usar o totem. Bloqueado = acesso negado</p></div>
        </v-card-text>
    </v-card>
</v-dialog>
  </v-container>
</template>


<script>
import axios from "@/plugins/axios";
import { eventHub } from "@/main";
import "v-mask/dist/v-mask.min.js";
import _ from 'lodash';
import moment from "moment";

export default {
  name: "ClienteEdit",
data() {
  return {
valid: false,
dialogAjudaMobile: false,
dialogConfirmar: false,
dialogExcluir: false,
dialogCredito: false,
dialogDebito: false,
dialogSaldoMobile: false,
dialogHistoricoMobile: false,
dialogDetalheMovimentacao: false,
movimentacaoSelecionada: {},
compraSelecionada: {},
dialogDetalheCompra: false,
    dataset: {
      loading: false,
      breadcrumbItems: [
        { text: "Homepage", to: "/home" },
        { text: "Clientes", to: "/clientes" },
        { text: "Editar Cliente", disabled: true }
      ]
    },
 historicoHeaders: [
  { text: "Data", value: "data", sortable: false },
  { text: "Máquina", value: "maquina", sortable: false },
  { text: "Valor", value: "valor", sortable: false },
  { text: "Tipo de Pagamento", value: "tipoPagamento", sortable: false, align: "center" },
  { text: "Detalhes", value: "acoes", sortable: false, width: "110px", align: "center" }
],
    historico: {
      data: [],
      loading: false,
      exporting: false,
      total: 0,
      options: { page: 1, itemsPerPage: 10 },
      filterSelected: 2,
      dataInicial: null,
      dataFinal: null,
      periodTypes: [
        { label: '7 dias', type: 1 },
        { label: '30 dias', type: 2 },
        { label: 'Últimos 3 meses', type: 3 },
        { label: 'Personalizado', type: 4 },
      ],
      footerOptions: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageOptions: [10, 20],
        pageText: '{0}-{1} de {2}',
      },
    },

movimentacaoHeaders: [
  { text: "Data", value: "data", sortable: false, width: "25%" },
  { text: "Origem", value: "origem", sortable: false, width: "25%" },
  { text: "Tipo", value: "tipo", sortable: false, width: "15%" },
  { text: "Valor", value: "valor", sortable: false, width: "25%", align: "center" },
  { text: "Detalhes", value: "acoes", sortable: false, width: "10%", align: "end" },
],

    movimentacao: {
      data: [],
      loading: false,
      exporting: false,
      total: 0,
      valor: null,
      observacao: '',
      options: { page: 1, itemsPerPage: 10 },
      filterSelected: 2,
      dataInicial: null,
      dataFinal: null,
      periodTypes: [
        { label: '7 dias', type: 1 },
        { label: '30 dias', type: 2 },
        { label: 'Últimos 3 meses', type: 3 },
        { label: 'Personalizado', type: 4 },
      ]
    },
    page: { title: "Editar Cliente" },
    cliente: {
      id: null,
      nome: "",
      email: "",
      telefone: "",
      cpf: "",
      bloqueado: false,
      dataCadastro: "",
      ultimaVisita: "",
      saldoAtual: 0
    },
    rules: {
      required: v => !!v || "Campo obrigatório",
      email: v => /.+@.+\..+/.test(v) || "E-mail inválido",
      cpf: v => {
        if (!v) return "Campo obrigatório";
        const cpfLimpo = v.replace(/\D/g, "");
        if (cpfLimpo.length !== 11) return "CPF inválido";
        if (/^(\d)\1{10}$/.test(cpfLimpo)) return "CPF inválido";
        const calcDigito = (cpf, pos) => {
          let soma = 0;
          for (let i = 0, peso = pos + 1; i < pos; i++, peso--) {
            soma += parseInt(cpf[i]) * peso;
          }
          let dig = 11 - (soma % 11);
          return dig > 9 ? 0 : dig;
        };
        if (calcDigito(cpfLimpo, 9) !== parseInt(cpfLimpo[9]) ||
            calcDigito(cpfLimpo, 10) !== parseInt(cpfLimpo[10])) {
          return "CPF inválido";
        }
        return true;
      }
    }
  };
},

  mounted() {
  eventHub.$on('CHANGE-OPERATION', () => {
    this.$router.push('/clientes');
  });
},
destroyed() {
  eventHub.$off('CHANGE-OPERATION');
},

async created() {
  await this.buscarCliente();
  this.normalizeRangeByType();
  this.normalizePeriodoMovimentacao();
},

computed: {
  totalPaginasMovimentacao() {
    const total = this.movimentacao.total || 0;
    const porPagina = this.movimentacao.options.itemsPerPage || 10;
    return Math.max(1, Math.ceil(total / porPagina));
  },
  totalPaginasHistorico() {
    const total = this.historico.total || 0;
    const porPagina = this.historico.options.itemsPerPage || 10;
    return Math.max(1, Math.ceil(total / porPagina));
  }
},
  methods: {
    async buscarCliente() {
  this.dataset.loading = true;
  try {
    const id = this.$route.params.id;
    const res = await axios.get("/api/clientes/" + id);
    this.cliente = {
      ...res.data,
      telefone: res.data.telefone ? res.data.telefone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3") : "",
      cpf: res.data.cpf ? res.data.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : ""
    }; 

  } finally {
    this.dataset.loading = false;
  }
},

abrirPopupSaldoMobile() {
  this.dialogSaldoMobile = true;
  this.movimentacao.filterSelected = 2; 
  this.normalizePeriodoMovimentacao();
  this.carregarMovimentacoes();
},

abrirPopupHistoricoMobile() {
  this.dialogHistoricoMobile = true;
  this.historico.filterSelected = 2; 
  this.normalizeRangeByType();
  this.carregarHistorico();
},
verDetalheMovimentacao(item) {
  this.movimentacaoSelecionada = item;
  this.dialogDetalheMovimentacao = true;
},

verDetalheCompra(item) {
  this.compraSelecionada = item;
  this.dialogDetalheCompra = true;
},

paginaAnteriorMovimentacao() {
  if (this.movimentacao.options.page > 1) {
    this.movimentacao.options.page--;
    this.carregarMovimentacoes();
  }
},

paginaProximaMovimentacao() {
  if (this.movimentacao.options.page < this.totalPaginasMovimentacao) {
    this.movimentacao.options.page++;
    this.carregarMovimentacoes();
  }
},


formatarValorMovimentacao(v) {
  if (!v) { this.movimentacao.valor = ''; return; }
  let limpo = v.replace(/\D/g, '');
  if (!limpo) { this.movimentacao.valor = ''; return; }
  let centavos = (parseInt(limpo) / 100).toFixed(2);
  this.movimentacao.valor = centavos.replace('.', ',');
},

async manterScrollHistorico(eventTarget) {
  await this.carregarHistorico();

  const paginacao = eventTarget ? eventTarget.closest('.popup-custom-pagination') : null;

  this.$nextTick(() => {
    if (paginacao && paginacao.scrollIntoView) {
      paginacao.scrollIntoView({ block: 'nearest' });
    }
  });
},

async paginaAnteriorHistorico(event) {
  if (this.historico.options.page > 1) {
    this.historico.options.page--;
    await this.manterScrollHistorico(event.currentTarget);
  }
},

async paginaProximaHistorico(event) {
  if (this.historico.options.page < this.totalPaginasHistorico) {
    this.historico.options.page++;
    await this.manterScrollHistorico(event.currentTarget);
  }
},

normalizePeriodoMovimentacao() {
  const now = moment();
  switch (this.movimentacao.filterSelected) {
    case 1:
      this.movimentacao.dataInicial = now.clone().subtract(6, 'd').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
      this.movimentacao.dataFinal = now.clone().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
      break;
    case 2:
      this.movimentacao.dataInicial = now.clone().subtract(30, 'd').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
      this.movimentacao.dataFinal = now.clone().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
      break;
    case 3:
      this.movimentacao.dataInicial = now.clone().subtract(3, 'month').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
      this.movimentacao.dataFinal = now.clone().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
      break;
    case 4:
      break;
  }
  this.movimentacao.options.page = 1;
},

async exportarMovimentacoes() {
  this.movimentacao.exporting = true;
  try {
    const params = {
      clienteId: this.cliente.id,
      ...(this.movimentacao.dataInicial && { dataInicial: this.movimentacao.dataInicial }),
      ...(this.movimentacao.dataFinal && { dataFinal: this.movimentacao.dataFinal })
    };
    const result = await axios.get("/api/movimentacoes/relatorio/export-to-excel", { params, responseType: 'arraybuffer' });

    let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'Movimentações.xlsx';
    link.click();

    this.$dialog.notify.info("Movimentações exportadas com sucesso!", { position: "top-right", timeout: 2000 });
  } catch (err) {
    const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao exportar movimentações.";
    this.$dialog.notify.error(msg, { position: "top-right", timeout: 5000 });
  } finally {
    this.movimentacao.exporting = false;
  }
},

async carregarMovimentacoes() {
  if (!this.cliente.id) return;
  this.movimentacao.loading = true;
  try {
    const garantirDataHoraCompleta = (data, fimDoDia = false) => {
      if (!data) return null;
      if (data.includes('T')) return data;
      return fimDoDia ? `${data}T23:59:59` : `${data}T00:00:00`;
    };
    const params = {
      clienteId: this.cliente.id,
      ...(this.movimentacao.dataInicial && { dataInicial: garantirDataHoraCompleta(this.movimentacao.dataInicial, false) }),
      ...(this.movimentacao.dataFinal && { dataFinal: garantirDataHoraCompleta(this.movimentacao.dataFinal, true) }),
      page: this.movimentacao.options.page - 1,
      size: this.movimentacao.options.itemsPerPage
    };
    const res = await axios.get("/api/movimentacoes", { params });
    this.movimentacao.data = res.data.content;
    this.movimentacao.total = res.data.page.totalElements;
  } catch (err) {
    const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao carregar movimentações.";
    this.$dialog.notify.error(msg, { position: "top-right", timeout: 4000 });
  } finally {
    this.movimentacao.loading = false;
  }
},

async registrarMovimentacao(tipo) {
 const valorNumerico = parseFloat(String(this.movimentacao.valor).replace(',', '.'));
if (!this.movimentacao.valor || isNaN(valorNumerico) || valorNumerico <= 0) {
    this.$dialog.notify.error("Informe um valor válido.", { position: "top-right", timeout: 3000 });
    return;
  }
  this.dialogCredito = false;
  this.dialogDebito = false;
  this.dataset.loading = true;
  try {
   const endpoint = tipo === 'CREDITO'
      ? `/api/clientes/${this.cliente.id}/adicionar-credito`
      : `/api/clientes/${this.cliente.id}/remover-credito`;

    await axios.post(endpoint, {
      valor: parseFloat(String(this.movimentacao.valor).replace(',', '.')),
      observacao: this.movimentacao.observacao || null
    });
    this.movimentacao.valor = null;
    this.movimentacao.observacao = '';
    this.$dialog.notify.success(
      tipo === 'CREDITO' ? "Crédito adicionado com sucesso." : "Débito registrado com sucesso.",
      { position: "top-right", timeout: 3000 }
    );
    await this.buscarCliente();
    await this.carregarMovimentacoes();
  } catch (err) {
    const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao registrar movimentação.";
    this.$dialog.notify.error(msg, { position: "top-right", timeout: 5000 });
  } finally {
    this.dataset.loading = false;
  }
},

normalizeRangeByType() {
  const now = moment();

  switch (this.historico.filterSelected) {
    case 1: // 7 dias
      this.historico.dataInicial = now
        .clone()
        .subtract(6, 'd')
        .startOf('day')
        .format('YYYY-MM-DDTHH:mm:ss');

      this.historico.dataFinal = now
        .clone()
        .endOf('day')
        .format('YYYY-MM-DDTHH:mm:ss');
      break;

    case 2: // 30 dias
      this.historico.dataInicial = now
        .clone()
        .subtract(30, 'd')
        .startOf('day')
        .format('YYYY-MM-DDTHH:mm:ss');

      this.historico.dataFinal = now
        .clone()
        .endOf('day')
        .format('YYYY-MM-DDTHH:mm:ss');
      break;

    case 3: // Últimos 3 meses
      this.historico.dataInicial = now
        .clone()
        .subtract(3, 'month')
        .startOf('day')
        .format('YYYY-MM-DDTHH:mm:ss');

      this.historico.dataFinal = now
        .clone()
        .endOf('day')
        .format('YYYY-MM-DDTHH:mm:ss');
      break;

   case 4: // Personalizado
      break;
  }

  this.historico.options.page = 1;
},

async exportarHistorico() {
  this.historico.exporting = true;
  try {
    const operacaoId = localStorage.getItem("operation");
    const params = {
      clienteId: this.cliente.id,
      operacaoId: operacaoId,
      ...(this.historico.dataInicial && { dataInicial: this.historico.dataInicial }),
      ...(this.historico.dataFinal && { dataFinal: this.historico.dataFinal })
    };
    const result = await axios.get("/api/venda/relatorio/export-to-excel", { params, responseType: 'arraybuffer' });

    let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'Histórico de Compras.xlsx';
    link.click();

    this.$dialog.notify.info("Histórico exportado com sucesso!", { position: "top-right", timeout: 2000 });
  } catch (err) {
    let mensagem = "Erro ao exportar histórico.";
    if (err && err.response && err.response.data) {
      try {
        const decoded = JSON.parse(new TextDecoder().decode(err.response.data));
        if (decoded.mensagem) mensagem = decoded.mensagem;
      } catch (e) { /* ignora */ }
    }
    this.$dialog.notify.error(mensagem, { position: "top-right", timeout: 5000 });
  } finally {
    this.historico.exporting = false;
  }
},

async carregarHistorico() {
  if (!this.cliente.id) return;
  this.historico.loading = true;
  try {
    const operacaoId = localStorage.getItem("operation");
    const params = {
      clienteId: this.cliente.id,
      operacaoId: operacaoId,
      ...(this.historico.dataInicial && { dataInicial: this.formatarDataInicioHistorico(this.historico.dataInicial) }),
      ...(this.historico.dataFinal   && { dataFinal:   this.formatarDataFimHistorico(this.historico.dataFinal)   }),
      page: this.historico.options.page - 1,
      size: this.historico.options.itemsPerPage
    };
    const res = await axios.get("/api/venda", { params });
    this.historico.data  = res.data.content;
    this.historico.total = res.data.page.totalElements;
  } catch (err) {
    const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao carregar histórico.";
    this.$dialog.notify.error(msg, { position: "top-right", timeout: 4000 });
  } finally {
    this.historico.loading = false;
  }
},
    abrirConfirmacao() {
      const valido = this.$refs.form.validate();
      if (!valido) {
        this.$dialog.notify.error("Preencha os campos obrigatórios corretamente.", {
          position: "top-right",
          timeout: 4000
        });
        return;
      }
      this.dialogConfirmar = true;
    },

    async salvarCliente() {
  this.dialogConfirmar = false;
  this.dataset.loading = true;
  try {
    // Montamos o payload EXATAMENTE como o ClienteDTO.java espera
    const payload = {
      id: this.cliente.id,
      nome: this.cliente.nome,
      email: this.cliente.email,
      telefone: this.cliente.telefone ? this.cliente.telefone.replace(/\D/g, "") : null,
      cpf: this.cliente.cpf ? this.cliente.cpf.replace(/\D/g, "") : null,
      bloqueado: this.cliente.bloqueado,
      // Se o objeto cliente tem .operacao.id, pegamos dele, senão enviamos null
      operacaoId: this.cliente.operacao ? this.cliente.operacao.id : this.cliente.operacaoId
    };

    await axios.put("/api/clientes/" + this.cliente.id, payload);
    
    this.$dialog.notify.info("Cliente atualizado com sucesso.", { position: "top-right", timeout: 4000 });
    this.voltar();
  } catch (err) {
    let mensagem = "Erro ao atualizar cliente.";
    if (err.response && err.response.data && err.response.data.mensagem) {
      mensagem = err.response.data.mensagem;
    }
    this.$dialog.notify.error(mensagem, { position: "top-right", timeout: 5000 });
  } finally {
    this.dataset.loading = false;
      }
    },

    async alternarStatusCliente() {
      this.dataset.loading = true;
      try {
        const res = await axios.put("/api/clientes/" + this.cliente.id + "/bloquear-desbloquear");
        this.cliente.bloqueado = res.data.bloqueado;
        const mensagem = this.cliente.bloqueado ? "Cliente bloqueado com sucesso." : "Cliente habilitado com sucesso.";
        const tipo = this.cliente.bloqueado ? "error" : "success";
        this.$dialog.notify[tipo](mensagem, { position: "top-right", timeout: 4000 });
      } catch (err) {
        let mensagem = "Erro ao alterar status do cliente.";
        if (err && err.response && err.response.data && err.response.data.mensagem) {
          mensagem = err.response.data.mensagem;
        }
        this.$dialog.notify.error(mensagem, { position: "top-right", timeout: 5000 });
      } finally {
        this.dataset.loading = false;
      }
    },

async excluirCliente() {
  this.dialogExcluir = false;
  this.dataset.loading = true;
  try {
    await axios.delete("/api/clientes/" + this.cliente.id);
    this.$dialog.notify.success("Cliente excluído com sucesso.", { position: "top-right", timeout: 4000 });
    this.voltar();
  } catch (err) {
   const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao excluir cliente.";
    this.$dialog.notify.error(msg, { position: "top-right", timeout: 5000 });
  } finally {
    this.dataset.loading = false;
  }
},

    abrirWhatsApp() {
  const telefone = this.cliente.telefone ? this.cliente.telefone.replace(/\D/g, "") : null;
  if (!telefone) {
    this.$dialog.notify.error("Cliente sem telefone cadastrado.", { position: "top-right", timeout: 3000 });
    return;
  }
 window.open(`https://wa.me/55${telefone}`, "_blank");
},

    voltar() {
      this.$router.push("/clientes");
    },

    formatarDataHora(data) {
      if (!data) return "-";
      const d = new Date(data);
      return d.toLocaleDateString("pt-BR") + " " + d.toLocaleTimeString("pt-BR");
    },

    formatarTelefone(v) {
      return v ? v.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3") : "";
    },

  formatarCPF(v) {
  return v ? v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "";
},

formatarTipoPagamento(tipo) {
  const mapa = {
    PIX: 'Pix',
    CREDITO: 'Crédito',
    DEBITO: 'Débito',
    SALDO_USUARIO: 'Saldo',
    DINHEIRO: 'Dinheiro'
  };
  return mapa[tipo] || tipo || '-';

},

formatarDataInicioHistorico(data) {
  if (!data) return null;
  return data.includes('T') ? data : `${data}T00:00:00`;
},

formatarDataFimHistorico(data) {
  if (!data) return null;
  return data.includes('T') ? data : `${data}T23:59:59`;
}
}
}
</script>

<style>
/* MODAIS MOBILE - Movimentações e Histórico */
.popup-mobile-dialog {
  border-radius: 12px;
  max-height: 85vh;
}

.popup-mobile-dialog .v-card__text {
  padding-right: 24px !important;
  padding-left: 24px !important;
}


.popup-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 16px;
}

.popup-mobile-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
}

.popup-mobile-close.v-btn {
  background-color: #f0f0f0 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  box-shadow: none !important;
}

.popup-mobile-close.v-btn .v-icon {
  color: #555 !important;
}

.popup-mobile-close.v-btn:hover {
  background-color: #e0e0e0 !important;
}

.popup-mobile-saldo {
  text-align: center !important;
}

/* PAGINAÇÃO DENTRO DOS POPUPS MOBILE - correção definitiva */
.popup-mobile-dialog .v-data-footer {
  padding: 8px 0 !important;
}

.popup-mobile-dialog .v-data-footer__icons-before,
.popup-mobile-dialog .v-data-footer__icons-after {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

.popup-mobile-dialog .v-data-footer__icons-before button,
.popup-mobile-dialog .v-data-footer__icons-after button {
  background-color: #f0f0f0 !important;
  border-radius: 50% !important;
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
  padding: 0 !important;
  opacity: 1 !important;
}

.popup-mobile-dialog .v-data-footer {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px;
}

.popup-mobile-dialog .v-data-footer__select {
  margin: 0 8px 0 0 !important;
}

.popup-mobile-dialog .v-data-footer__pagination {
  margin: 0 8px !important;
}

.popup-mobile-dialog .v-data-footer__icons-before button .v-icon,
.popup-mobile-dialog .v-data-footer__icons-after button .v-icon {
  color: #333 !important;
  opacity: 1 !important;
  font-size: 20px !important;
}

.popup-mobile-dialog .v-data-footer__icons-before button.v-btn--disabled,
.popup-mobile-dialog .v-data-footer__icons-after button.v-btn--disabled {
  background-color: transparent !important;
}

.popup-mobile-dialog .v-data-footer__icons-before button.v-btn--disabled .v-icon,
.popup-mobile-dialog .v-data-footer__icons-after button.v-btn--disabled .v-icon {
  color: #ccc !important;
}

/* Espaço entre os cards no desktop e mobile */
.card-form-outlined {
  margin-bottom: 4px;
}

/* Selector com .cliente-edit-popup-table pra não vazar pra tabelas de outras
   telas (esse <style> não é scoped — sem essa classe, valia globalmente). */
.app-table.cliente-edit-popup-table.v-data-table--mobile table {
  table-layout: auto !important;
  width: 100% !important;
}

.app-table.cliente-edit-popup-table.v-data-table--mobile .v-data-table__mobile-row {
  padding: 2px 0 !important;
  min-height: auto !important;
}

.app-table.cliente-edit-popup-table.v-data-table--mobile .v-data-table__mobile-row__header {
  font-size: 13px !important;
  color: #333 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.app-table.cliente-edit-popup-table.v-data-table--mobile .v-data-table__mobile-row__cell {
  font-size: 14px !important;
}

.app-table.cliente-edit-popup-table.v-data-table--mobile .v-data-table__mobile-table-row {
  border-bottom: 1px solid #eee !important;
  padding-bottom: 4px !important;
  margin-bottom: 4px !important;
}

.popup-date-field input[type="datetime-local"] {
  font-size: 13px;
}

.popup-custom-pagination {
  display: flex;
  flex-direction: column;
  padding: 12px 4px 4px 4px;
  margin-top: 8px;
  border-top: 1px solid #eee;
  gap: 10px;
}

.popup-pagination-topo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.popup-itens-por-pagina {
  max-width: 80px;
  flex: 0 0 auto;
}

.popup-pagination-label {
  font-size: 13px;
  color: #666;
  font-weight: 600;
  white-space: nowrap;
}

.popup-pagination-botoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.popup-pagination-botoes .v-btn {
  min-width: auto !important;
  padding: 0 8px !important;
  font-size: 12px !important;
  text-transform: none;
}
.app-table.cliente-edit-popup-table.v-data-table--mobile .v-data-table__mobile-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.app-table.cliente-edit-popup-table.v-data-table--mobile .v-data-table__mobile-row__cell {
  display: block;
  flex: 0 1 auto;
  min-width: 0;
  text-align: right;
  white-space: normal;
  word-break: break-word;
}
.v-btn.v-btn--icon {
  min-width: 36px !important;
  width: 36px !important;
}

.popup-exportar-btn.v-btn {
  min-width: 0 !important;
  padding: 0 10px !important;
  font-size: 12px !important;
  height: 40px !important;
}

@media (max-width: 599px) {
  .popup-mobile-dialog .v-dialog__content .v-btn.popup-exportar-btn.v-btn--block {
    width: 100% !important;
    min-width: 0 !important;
  }
  .popup-mobile-dialog .v-dialog__content .v-row.mb-2.d-flex.d-sm-none .v-col {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
}

.v-card { border-radius: 12px; }
.title-container { gap: 16px; }
.page-title { font-size: 24px; font-weight: 700; }
.v-btn { min-width: 130px; font-weight: 600; }
.v-btn.v-btn--icon {
  min-width: 36px !important;
  width: 36px !important;
}
.green--text { color: #28a745 !important; }
.error--text { color: #dc3545 !important; }
.ga-3 { gap: 24px; }
.card-form-outlined .v-input { margin-bottom: 8px; }


@media (max-width: 600px) {
    .v-data-footer {
        flex-wrap: nowrap !important;
        justify-content: center !important;
        padding: 4px 0 !important;
        width: 100% !important;
    }

    .v-data-footer__navigation {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-wrap: nowrap !important;
        width: auto !important;
    }

    .v-data-footer__select,
    .v-data-footer__pagination,
    .v-data-footer__icons-before,
    .v-data-footer__icons-after {
        margin: 0 4px !important;
        padding: 0 !important;
        flex: none !important;
        width: auto !important;
        display: inline-flex !important;
    }

    .v-data-footer__pagination,
    .v-data-footer__select {
        font-size: 12px !important;
    }
}
.popup-filtro-quebra {
  display: none;
  width: 100%;
  height: 0;
}

@media (min-width: 960px) {
  .popup-mobile-dialog .flex-nowrap {
    flex-wrap: nowrap !important;
    gap: 0px !important;
  }

  .popup-mobile-dialog .flex-nowrap > .col,
  .popup-mobile-dialog .flex-nowrap > [class*="col-"] {
    padding-left: 0px !important;
    padding-right: 0px !important;
    margin-right: 5px !important;
  }

  .popup-mobile-dialog .flex-nowrap > .col-2 {
    flex: 0 0 132px !important;
    max-width: 132px !important;
  }

  .popup-mobile-dialog .flex-nowrap .d-flex[style*="gap"] {
    gap: 4px !important;
    margin-right: 5px !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-btn {
    min-width: unset !important;
    padding: 0 8px !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-text-field {
    max-width: 132px !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-text-field input {
  padding-right: 16px !important;
}

  .popup-mobile-dialog .flex-nowrap .v-text-field input[type="date"]::-webkit-calendar-picker-indicator {
    display: none !important;
    -webkit-appearance: none !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-text-field input[type="date"]::-webkit-clear-button {
    display: none !important;
    -webkit-appearance: none !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-btn[width="110"] {
    width: 58px !important;
  }
}
@media (min-width: 1280px) {
  .popup-mobile-dialog .flex-nowrap > .col-2 {
    flex: 0 0 190px !important;
    max-width: 190px !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-text-field {
    max-width: 190px !important;
  }

  .popup-mobile-dialog .flex-nowrap > .col,
  .popup-mobile-dialog .flex-nowrap > [class*="col-"] {
    margin-right: 6px !important;
  }

  .popup-mobile-dialog .flex-nowrap .d-flex[style*="gap"] {
    gap: 4px !important;
    margin-right: 6px !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-btn[width="110"] {
    width: 150px !important;
  }

  .popup-mobile-dialog .flex-nowrap .v-btn:not([width="110"]) {
    padding: 0 10px !important;
  }
}
</style>
